import React, { Component } from "react";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Col,
  Progress
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { faAngleDoubleDown } from "@fortawesome/free-solid-svg-icons";
import "./Header.css";
import httpClient from '../../services/HttpClient';

class Header extends Component {

  state = {
    activePage: 0,
    isLoading: false,
    showResetPasswordModal: false,
    resetPassword: '',
    resetPasswordConfirm: '',
    errorMsg: ''
  };

  logout = () => {
    localStorage.setItem("token", "");
    window.location.href = '';
  };

  showPasswordResetModal = () => {
    this.setState({
      resetPassword: '',
      resetPasswordConfirm: '',
      isLoading: false,
      showResetPasswordModal: true
    });
  }

  closePasswordResetModal = () => {
    this.setState({
      showResetPasswordModal: false
    });
  }

  setResetPassword = (e) => {
    this.setState({
      resetPassword: e.target.value
    });
  }

  setResetPasswordConfirm = (e) => {
    this.setState({
      resetPasswordConfirm: e.target.value
    });
  }

  resetPassword = (e) => {
    e.preventDefault();
    const { resetPassword, resetPasswordConfirm } = this.state;
    if(resetPassword !== resetPasswordConfirm) {
      this.setState({
        errorMsg: 'The passwords entered above do not match.'
      });
    } else {
      this.setState({
        isLoading: true
      }, () => {
        const apiBaseUrl = window.clipship_config.ApiBaseUrl;
        httpClient.put(`${apiBaseUrl}/user/changepassword`, {'new_password': resetPassword}).then((response) => {
          if (response.status === 200) {
            this.closePasswordResetModal();
          } else {
            const errorMsg = response.data?.error || "There was an issue resetting you password. Please try again.";
            this.setState({
              isLoading: false,
              errorMsg: errorMsg
            });
          }
        })
        .catch((error) => {
          const errorMessage = error.response?.data?.error || "There was an issue resetting you password. Please try again.";

          this.setState({
            isLoading: false,
            errorMsg: errorMessage
          });
        });
      });
    }
  }

  extractRoleFromToken = (token) => {
    if (!token) {
      throw new Error("Token is required");
    }
  
    // Split the token into its parts
    const parts = token.split('.');
    if (parts.length !== 3) {
      throw new Error("Invalid token format");
    }
  
    // Decode the payload (the second part of the token)
    const payload = JSON.parse(atob(parts[1]));
  
    // Return the 'role' property if it exists
    return payload.role;
  }

  manageUsers = () => {
    window.location.href = "#/users";
  }

  goHome = () => {
    if (window.location.hash === "#/main") {
      // Temporarily change the hash to trigger a reload
      window.location.hash = "#/reload";
      setTimeout(() => {
        window.location.hash = "#/main";
      }, 0); // Change back to #/main
    } else {
      // Navigate to #/main
      window.location.href = "#/main";
    }
  }

  goToMyRequests = () => {
    window.location.href = "#/requests";
  }

  openHelp = () => {
    window.open(window.clipship_config.HelpLink, '_blank', 'noopener,noreferrer');
  }


  render() {
    const { showResetPasswordModal, resetPassword, resetPasswordConfirm, isLoading, errorMsg } = this.state;
    const styleForHeader = {
      position: "absolute",
      top: "46px",
      left: "-142px"
    };

    const token = localStorage.getItem("token", "");
    const role = !!token ? this.extractRoleFromToken(token) : '';

    return (
      <>
        <div className="main-header-container">
          <nav className="navbar" style={{paddingTop:0}}>
            <div>
              <img style={{height:40, margin:10}} src="https://provopw.org/clipandship/header_logo.png" />
            </div>
            <h2 className="main-header-container__heading">
              Provo Digital Data Request
            </h2>
            <div></div>
            {!!token &&
            <UncontrolledDropdown direction="left">
              <DropdownToggle 
                className="main-header-container__dropdown rounded-pill"
              >
                <FontAwesomeIcon icon={faAngleDoubleDown} size="1x" />
              </DropdownToggle>
              <DropdownMenu className="navbar-menu" style={styleForHeader}>
                <DropdownItem onClick={this.goHome}>
                  Create New Request
                </DropdownItem>
                <DropdownItem onClick={this.goToMyRequests}>
                  My Requests
                </DropdownItem>
                {role === 'ADMIN' &&
                  <DropdownItem onClick={this.manageUsers}>
                  Manage Users
                </DropdownItem>
                }
                <DropdownItem onClick={this.showPasswordResetModal}>
                  Change Password
                </DropdownItem>
                <DropdownItem onClick={this.openHelp}>
                  Help
                </DropdownItem>
                <DropdownItem onClick={this.logout}>
                  Logout
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
            }
          </nav>
        </div>
        <Modal isOpen={showResetPasswordModal} toggle={()=>{}} >
          <ModalHeader toggle={this.closePasswordResetModal}>Reset Password</ModalHeader>
          <ModalBody>
            <Form className="login-form">
              <FormGroup>
                <Label for="email">New Password</Label>
                <Input
                  id="reset-password"
                  name="reset-password"
                  type="password"
                  disabled={isLoading}
                  value={resetPassword}
                  onChange={this.setResetPassword}
                  required
                />
              </FormGroup>
              <FormGroup>
                <Label for="email">Confirm New Password</Label>
                <Input
                  id="reset-password-confirm"
                  name="reset-password-confirm"
                  type="password"
                  disabled={isLoading}
                  value={resetPasswordConfirm}
                  onChange={this.setResetPasswordConfirm}
                  required
                />
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter>
            {!!errorMsg &&
              <Col md="12" style={{color:'red', marginBottom: 10}}>
                {errorMsg}
              </Col>
            }
            {isLoading && <Col md="12"><Progress animated value="100" /></Col>}
            {!isLoading &&
              <>
                <Button className="rounded-pill" color="success" onClick={this.resetPassword}>Update</Button>
                <Button className="rounded-pill" color="danger" onClick={this.closePasswordResetModal}>Cancel</Button>
              </>
            }
          </ModalFooter>
        </Modal>
      </>
    );
  }
}


export default Header;
